<template>
  <div class="blog-section section-padding pt-50">
    <div class="container">
      <div class="row">
        <div class="col-xl-7 col-lg-7">
          <div class="section-title text-up">
            <h2>{{vars.titleText}}</h2>
          </div>
        </div>
      </div>
       
      <div class="row">
        <div class="blog-carousel owl-carousel">
          <div
            class="single-blog-item"
            v-for="(item, index) in items"
            :key="index"
          >
            <div class="blog-bg">
              <library-iframe v-if="item.video" :src="item.video" />
              <img v-if="item.image" :src="item.image" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin'

export default defineNuxtComponent({
  mixins: [ComponentMixin],
  
  computed: {
    items() {
      return this.groupedVariables.items || []
    },
  },
  
  mounted() {
    this.$nextTick(() => {
      if (process.client) {
        this.initCarousel()
      }
    })
  },
  
  watch: {
    items(newVal) {
      if (newVal.length > 0) {
        this.$nextTick(() => {
          this.initCarousel()
        })
      }
    }
  },
  
  methods: {
    initCarousel() {
      if (typeof window !== 'undefined' && window.$) {
        const $ = window.$
        $('.blog-carousel').owlCarousel('destroy') // varsa eskiyi yok et
        $('.blog-carousel').owlCarousel({
          loop: true,
          margin: 30,
          nav: true,
          dots: false,
          navText: ["<i class='las la-arrow-left'></i>", "<i class='las la-arrow-right'></i>"],
          responsive: {
            0: {
              items: 1,
            },
            768: {
              items: 2,
            },
            1200: {
              items: 3,
            },
          }
        })
      }
    }
  }
})
</script>